export enum PtaNewRequestEnum {
    MODULE_ACCESS = 'View',
    CREATE_NEW_PTA_REQUEST_ACCESS = 'PTA_Request_Create',
}
